<template>
    <div
        v-if="show"
        data-test-overlay
        :class="{'light': light, 'darl': !light}"
        class="splash grid-y align-center-middle"
    >
        <slot />
    </div>
</template>
<script>
export default {
    name: 'PageOverlay',
    props: {
        show: {
            type: Boolean,
            default() {
                return false;
            }
        },
        light: {
            type: Boolean,
            default() {
                return true;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.splash {
    width: 100vw;
    height: 100vh;
    z-index: 10008;
    position: fixed;
    top: 0px;
    left: 0;

    &.light {
        background-color: rgba(255, 255, 255, 0.8);
    }

    &.dark {
        background-color: rgba(90,90,90,0.5);
    }
}
</style>
